import { IComboVariant, ISavedModifier } from '@/_types'
import { IProduct } from '@/entities/product/model/types'
import { AspectRatio, Box, Card, Text } from '@chakra-ui/react'
import { useCustomLocale } from '@/_hooks/useCustomLocale'
import { QuestionIcon } from '@/_assets/icon-components'
import Image from 'next/image'

const ComboCard = ({
  product,
  selectedVariant,
  onAdd,
}: {
  product: IProduct
  selectedVariant: IComboVariant
  onAdd: (e: ISavedModifier[]) => void
}) => {
  const currentLocale = useCustomLocale()

  const handleClick = () => {
    onAdd([])
  }

  return (
    <Card.Root
      variant={'subtle'}
      rounded={16}
      border={'1px solid red'}
      borderColor={
        product.id === selectedVariant?.variant_id ? 'primary' : 'text.muted'
      }
      bg='background'
      color='text'
    >
      <Card.Body gap="2" p={2} onClick={handleClick}>
        <Card.Header bg='background.card' color='text' p={0} rounded={12}>
          <Box>
            <AspectRatio position="relative" ratio={1 / 1}>
              {product.image ? (
                <Image
                  src={process.env.BASE_URL + product.image}
                  alt={'pic'}
                  style={{ objectFit: 'cover', borderRadius: '12px' }}
                  loading="eager"
                  fill
                />
              ) : (
                <Box opacity={0.5}>
                  <QuestionIcon color='currentColor' />
                </Box>
              )}
            </AspectRatio>
          </Box>
        </Card.Header>
        <Card.Title mt={1} mb={3} color='text'>
          <Text fontSize={'sm'} fontWeight={400} lineHeight={1.2}>
            {product?.title?.[currentLocale]}
          </Text>
        </Card.Title>
      </Card.Body>
    </Card.Root>
  )
}

export default ComboCard
